import { Injectable } from '@angular/core';

import { ContentPageMetaResolver } from '@spartacus/core';
import { Observable } from 'rxjs';

import { DpBasePageMetaResolver } from './base-page-meta.resolver';

export interface PageMetaTitleResolver {
  resolveTitle(): Observable<string | undefined>;
}

@Injectable()
export class DpContentPageMetaResolver extends ContentPageMetaResolver implements PageMetaTitleResolver {
  constructor(protected basePageMetaResolver: DpBasePageMetaResolver) {
    super(basePageMetaResolver);
  }

  resolveMetaTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveMetaTitle();
  }
}
